// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Banner-cls1___5368cd9dac8c86d830a{/*!*/}.Banner-cls2___dd14d8ce5bfebdcc02c{height:44px}@media(min-width: 375px){.Banner-cls2___dd14d8ce5bfebdcc02c{height:32px;padding:0 12px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Banner-cls1___5368cd9dac8c86d830a",
	"cls2": "Banner-cls2___dd14d8ce5bfebdcc02c Banner-cls1___5368cd9dac8c86d830a"
};
export default ___CSS_LOADER_EXPORT___;
